/** Fundswalle DigiLocker endpoints only — never use other brand domains */

export const DIGITAP_APPLY_LOAN_PATH = "/apply-loan";
export const DIGITAP_LANDING_PATH = "/landing";
export const DIGITAP_POLL_MS = 5000;
export const DIGITAP_POLL_MAX_MS = 5 * 60 * 1000;
export const DIGITAP_WINDOW_WATCH_MS = 800;
/** After DigiLocker tab closes, poll for this long then unlock Continue */
export const DIGITAP_POST_CLOSE_POLL_MS = 45 * 1000;
export const DIGITAP_POLL_NETWORK_FAIL_MAX = 4;

/**
 * /apply-loan DigiLocker start
 * https://fundswalla.in/loan_backend/sendAadhaarOtp2.php
 */
export const DIGITAP_SEND_KYC_URL =
  "https://fundswalla.in/loan_backend/sendAadhaarOtp2.php";

/**
 * /landing DigiLocker start
 * https://fundswalla.in/loan_backend/sendAadhaarOtpla.php
 */
export const DIGITAP_SEND_KYC_URL_LANDING =
  "https://fundswalla.in/loan_backend/sendAadhaarOtpla.php";

/** Backend DigiLocker callback (server-side redirect) */
export const DIGITAP_VERIFY_URL =
  "https://fundswalla.in/loan_backend/verifyAadhaarOtp2.php";
export const DIGITAP_VERIFY_URL_LANDING =
  "https://fundswalla.in/loan_backend/verifyAadhaarOtpla.php";

/**
 * KYC status poll — Fundswalla TaskApi only:
 * https://fundswalla.in/Api/TaskApi/getDigitapKycDetails/{transactionId}
 */
export const digitapKycDetailsUrl = (transactionId) => {
  const txnId = String(transactionId || "")
    .replace(/[{}]/g, "")
    .replace(/\D/g, "");
  return `https://fundswalla.in/Api/TaskApi/getDigitapKycDetails/${encodeURIComponent(
    txnId
  )}`;
};

/** @deprecated use digitapKycDetailsUrl */
export const digitapKycDetailsUrls = (transactionId) => [
  digitapKycDetailsUrl(transactionId),
];

export const getDigitapSendKycUrl = (enquirySource) => {
  const source = String(enquirySource || "").trim().toLowerCase();
  if (source === "landing") return DIGITAP_SEND_KYC_URL_LANDING;
  return DIGITAP_SEND_KYC_URL;
};

export const getApplyLoanSiteReturnUrl = () => {
  if (typeof window === "undefined") {
    return "https://fundswalle.com/apply-loan";
  }
  const path = window.location.pathname || DIGITAP_APPLY_LOAN_PATH;
  if (path.startsWith("/landing")) {
    return `${window.location.origin}/landing`;
  }
  return `${window.location.origin}${DIGITAP_APPLY_LOAN_PATH}`;
};
